import { DateTime } from "luxon";
import { FieldValues, useFormContext, Controller, Path } from "react-hook-form";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";
import { TimePicker } from "@mui/x-date-pickers";
import { FormControl } from "@mui/material";

export function TimeInput<F extends FieldValues, T = DateTime>(props: {
  label: string;
  source: Path<F>;
  sx?: SxProps<Theme>;
  size?: "small";
  helperText?: string;
  validate?: (value: T) => true | string;
  toPickerValue?: (value: T | null | undefined) => DateTime | null;
  fromPickerValue?: (value: DateTime | null) => T | null;
}) {
  const { source, sx, label, size, helperText, validate, toPickerValue, fromPickerValue } = props;
  const { control } = useFormContext<F>();
  const { width } = (sx || {}) as any;
  return (
    <Controller
      name={source}
      control={control}
      render={({ field: { onChange, value, onBlur }, formState }) => {
        const error = formState.errors[source]?.message as any;
        const errorMessage = typeof error === "string" ? error : error?.message.toString();
        const pickerValue = toPickerValue ? toPickerValue(value) : (value as DateTime | null);
        return (
          <FormControl sx={width ? { width, minWidth: width, maxWidth: width } : undefined}>
            <TimePicker
              label={label}
              value={pickerValue}
              sx={sx}
              onChange={(newValue) => {
                onChange(fromPickerValue ? fromPickerValue(newValue) : newValue);
              }}
              ampm={false}
              slotProps={{
                textField: {
                  required: true,
                  size: size,
                  onBlur,
                  ...(errorMessage ? { error: true, helperText: errorMessage } : { helperText }),
                },
              }}
            />
          </FormControl>
        );
      }}
      rules={{
        validate: (value) => {
          if (!value) {
            return "Bitte wähle eine Uhrzeit aus.";
          }
          const dateTimeValue = toPickerValue ? toPickerValue(value) : (value as DateTime);
          if (!dateTimeValue) {
            return "Bitte wähle eine Uhrzeit aus.";
          }
          if (dateTimeValue.hour === 0 && dateTimeValue.minute === 0) {
            return "Bitte wähle eine andere Uhrzeit als 00:00 Uhr aus.";
          } else if (validate) {
            return validate(value as T);
          } else {
            return true;
          }
        },
      }}
    />
  );
}
